export default {
    s: {
        height: 36,
        width: 250,
        x: 55,
        y: 302,
    },
    m: {
        height: 64,
        width: 442,
        x: 163,
        y: 480,
    },
    l: {
        height: 75,
        width: 516,
        x: 254,
        y: 347,
    },
    xl: {
        height: 89,
        width: 615,
        x: 412,
        y: 405,
    },
};
